export default "__VITE_ASSET__BWRUgLmX__"